import { forwardRef, type Ref, type SVGProps } from "react";
const IconUnconstrainedFlyOverFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m22.648 7.516-5.73-5.174a1.404 1.404 0 0 0-1.836 0l-5.73 5.174a2.74 2.74 0 0 0-.89 2.016v8.372c0 .733.613 1.327 1.37 1.327h12.336c.757 0 1.37-.594 1.37-1.327V9.532c0-.761-.321-1.49-.89-2.016"
    />
    <path
      fill="currentColor"
      d="M6.422 13.733C3.7 15.108 2 17.063 2 19.23c0 3.756 5.103 6.871 11.78 7.444l-2.57 1.285a1.077 1.077 0 0 0 .964 1.926l4.535-2.267c1.588-.794 1.588-3.06 0-3.853l-4.535-2.268a1.077 1.077 0 0 0-.963 1.927l2.07 1.035c-2.44-.284-4.565-.937-6.16-1.795-2.25-1.212-2.967-2.525-2.967-3.434 0-.808.566-1.934 2.268-3.024zm21.424 5.497c0-.806-.564-1.928-2.258-3.017v-2.475C28.304 15.113 30 17.065 30 19.23c0 2.653-2.545 4.985-6.392 6.329a1.098 1.098 0 1 1-.54-2.087l-.001-.007a13.6 13.6 0 0 0 1.811-.801c2.25-1.212 2.968-2.525 2.968-3.434"
    />
  </svg>
);
const ForwardRef = forwardRef(IconUnconstrainedFlyOverFilledSVG);
ForwardRef.displayName = "IconUnconstrainedFlyOverFilled";
export { ForwardRef as IconUnconstrainedFlyOverFilled };
